import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../..';

const selectLayoutState = (state: RootState) => state.layout;

const selectIsDownloadAppModalOpened = createSelector(
  selectLayoutState,
  (layout) => layout.isDownloadAppModalOpened
);

export default {
  selectIsDownloadAppModalOpened
};
